/* Herbz / Section Store: display-only Mystery bag milestone and near-goal notice.
   The actual gift eligibility and fulfilment remain controlled by AutoCart. */
(() => {
  'use strict';
  if (window.herbzMysteryRewardsReady) return;
  window.herbzMysteryRewardsReady = true;

  const GIFT_THRESHOLD_DKK = 1500;
  const NEAR_THRESHOLD_DKK = 250;
  const GIFT_TITLE = 'Mystery bag';
  const KEY = `herbz-mystery-dismissed-${GIFT_THRESHOLD_DKK}`;
  const ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 9h18v4H3zM5 13v8h14v-8M12 9v12"/><path d="M12 9H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/></svg>';
  const CSS = `
    .herbz-mystery-notice {
      position:relative; display:grid; grid-template-columns:28px minmax(0,1fr) 36px;
      gap:10px; align-items:start; margin:2px 16px 16px; padding:14px 10px 14px 14px;
      border:1px solid #737426; border-radius:14px; background:#252617;
      color:#f4f4e8; font:inherit; font-size:13px; line-height:1.5;
      animation:herbz-mystery-appear .2s ease-out;
    }
    .herbz-mystery-notice[hidden] { display:none !important; }
    .herbz-mystery-notice > svg { width:25px; height:25px; color:#e2e037; margin-top:2px; }
    .herbz-mystery-notice strong { display:block; color:#e2e037; font-size:14px; line-height:1.35; margin-bottom:4px; }
    .herbz-mystery-notice p { margin:0; }
    .herbz-mystery-notice button {
      display:grid; place-items:center; width:36px; height:36px; border:0;
      border-radius:8px; padding:8px; background:transparent; color:#e5e5d2; cursor:pointer;
    }
    .herbz-mystery-notice button:hover { background:#ffffff12; }
    .herbz-mystery-notice button:focus-visible { outline:2px solid #e2e037; outline-offset:2px; }
    .herbz-mystery-notice button svg { width:18px; height:18px; }
    @keyframes herbz-mystery-appear { from { opacity:0; transform:translateY(-4px); } to { opacity:1; transform:none; } }
    @media (prefers-reduced-motion:reduce) { .herbz-mystery-notice { animation:none; } }
  `;
  let installedBlock = null;
  let latestCart = null;
  let unsubscribe = null;
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (_) {}

  function saveDismissed(value) {
    dismissed = value;
    try { if (value) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (_) {}
  }

  function updateNotice() {
    const block = installedBlock;
    const bar = block?.sections?.rewardBar;
    const root = block?.shadowRoot;
    if (!root || !bar || !latestCart) return;
    const nativeContainer = root.querySelector('.cart-reward-bar');
    if (!nativeContainer) return;
    const view = bar.currentRewardBarView;
    const currency = String(latestCart.currency || block.currencyCode || '').toUpperCase();
    if (latestCart.item_count === 0) saveDismissed(false);
    let notice = root.querySelector('.herbz-mystery-notice');
    const remaining = Math.max(0, Math.round(GIFT_THRESHOLD_DKK * 100 - Number(view?.progress?.currentValue || 0)));
    const show = currency === 'DKK' && view?.visible && !dismissed &&
      remaining > 0 && remaining <= NEAR_THRESHOLD_DKK * 100 &&
      !document.documentElement.classList.contains('herbz-autocart-open');
    if (!notice && !show) return;
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'herbz-mystery-notice';
      notice.innerHTML = `${ICON}<div role="status" aria-live="polite" aria-atomic="true"><strong>Du er tæt på en mystery bag!</strong><p></p></div><button type="button" aria-label="Luk påmindelsen">${'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>'}</button>`;
      notice.querySelector('button').addEventListener('click', () => {
        saveDismissed(true);
        notice.hidden = true;
      });
      nativeContainer.insertAdjacentElement('afterend', notice);
    }
    const text = `Tilføj for ${new Intl.NumberFormat('da-DK', {style:'currency', currency:'DKK'}).format(remaining / 100)} mere for at låse op for din gave.`;
    const paragraph = notice.querySelector('p');
    if (paragraph.textContent !== text) paragraph.textContent = text;
    notice.hidden = !show;
  }

  function install() {
    const block = document.querySelector('section-store--cart-block');
    const api = window.SectionStoreCart;
    const bar = block?.sections?.rewardBar;
    if (!block?.shadowRoot || !api || !bar?.settings || !bar.progress?.thresholdFor ||
        typeof api.subscribe !== 'function' || !block.state?.stateSnapshot) return;
    if (installedBlock === block) { updateNotice(); return; }
    const currency = String(block.currencyCode || api.getCart?.()?.currency || '').toUpperCase();
    const original = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(bar.settings), 'config');
    if (!original?.get || currency !== 'DKK' || bar.settings.config.unlock_by === 'item_quantity') return;

    // Extend ONLY this reward-bar renderer's settings. Do not modify block.config:
    // its reward tiers also control Section Store's actual gift/discount logic.
    Object.defineProperty(bar.settings, 'config', {
      configurable: true,
      get() {
        const settings = original.get.call(this);
        const tiers = Array.isArray(settings.tiers) ? [...settings.tiers] : Object.values(settings.tiers || {});
        const exists = tiers.some(tier => tier.reward_type === 'free_gift' &&
          bar.progress.thresholdFor(tier, settings, block.currencyExchangeRate || 1) === GIFT_THRESHOLD_DKK * 100);
        if (!exists) tiers.push({
          short_id:'herbz-mystery-display', title:GIFT_TITLE, threshold:String(GIFT_THRESHOLD_DKK),
          icon_type:'free_gift', reward_type:'free_gift', free_gifts:[],
          hide_icon_and_title:false, market_thresholds:[]
        });
        return {...settings, tiers, show_tier_thresholds:true};
      }
    });
    let style = block.shadowRoot.querySelector('#herbz-mystery-notice-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'herbz-mystery-notice-style';
      style.textContent = CSS;
      block.shadowRoot.appendChild(style);
    }
    unsubscribe?.();
    installedBlock = block;
    bar.render(block.state.stateSnapshot);
    // Public subscription runs after Section Store's own render subscription.
    unsubscribe = api.subscribe(cart => { latestCart = cart; updateNotice(); });
    latestCart = api.getCart?.() || latestCart;
    updateNotice();
  }

  window.addEventListener('section-store:cart:ready', install);
  window.addEventListener('section-store:cart:opened', updateNotice);
  window.addEventListener('load', install, {once:true});
  document.addEventListener('shopify:section:load', install);
  new MutationObserver(updateNotice).observe(document.documentElement, {
    attributes:true, attributeFilter:['class']
  });
  customElements.whenDefined('section-store--cart-block').then(install);
  install();
})();
